/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { SPA_BUILD_ID } from '@/config/appBuild'
import { CRM_SERVICE_WORKER_URL } from '@/services/spaBuildMeta'

// Не регистрировать SW на страницах Nova (Laravel Nova), иначе workbox-*.js запрашивается с того же origin и отдаётся HTML (404)
const isNovaPath = typeof window !== 'undefined' && window.location.pathname.startsWith('/nova')

let controllerChangeBound = false

function bindControllerChangeOnce(): void {
  if (controllerChangeBound || !('serviceWorker' in navigator)) {
    return
  }
  controllerChangeBound = true
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // Баннер «новая версия» сверяется с API; событие лишь триггерит дополнительную проверку.
    window.dispatchEvent(new CustomEvent('crm-pwa-sw-updated'))
  })
}

if (process.env.NODE_ENV === 'production' && !isNovaPath) {
  bindControllerChangeOnce()
  // Версия в URL: после деплоя браузер подхватывает новый SW (см. docs/SPA_BUILD_ID.md).
  register(CRM_SERVICE_WORKER_URL, {
    ready () {
      // PWA готово к работе
    },
    registered (registration) {
      // Периодический update SW; устаревание бандла определяет GET /api/meta/spa-build.
      setInterval(() => {
        registration.update().catch(() => undefined)
      }, 1000 * 60 * 60)
    },
    cached () {
      // Контент закеширован для offline использования
    },
    updatefound () {
      // Найдено обновление SW — баннер покажет API-сравнение build id
    },
    updated (registration) {
      // Активируем waiting SW; жёсткий reload делает пользователь через баннер.
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      }
      window.dispatchEvent(new CustomEvent('crm-pwa-sw-updated'))
    },
    offline () {
      if ((window as any).$notify) {
        (window as any).$notify({
          title: '📡 Offline режим',
          message: 'Нет подключения к интернету\n\nНекоторые функции могут быть недоступны',
          icon: 'mdi-wifi-off',
          type: 'warning'
        })
      }
    },
    error (error) {
      console.error('Ошибка при регистрации Service Worker:', error)
    }
  })
}

// Регистрируем Firebase Messaging Service Worker
// Делаем это ОДИН раз, проверяя что он еще не зарегистрирован
let isFirebaseSWRegistering = false;

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production' && !isNovaPath) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    const hasFirebaseSW = registrations.some(reg =>
      reg.scope.includes('firebase-messaging-sw') ||
      reg.active?.scriptURL?.includes('firebase-messaging-sw.js') ||
      reg.waiting?.scriptURL?.includes('firebase-messaging-sw.js') ||
      reg.installing?.scriptURL?.includes('firebase-messaging-sw.js')
    );

    if (!hasFirebaseSW && !isFirebaseSWRegistering) {
      isFirebaseSWRegistering = true;
      const firebaseSwUrl = `/firebase-messaging-sw.js?v=${encodeURIComponent(SPA_BUILD_ID)}`
      navigator.serviceWorker
        .register(firebaseSwUrl, { scope: '/' })
        .then(() => {
          isFirebaseSWRegistering = false;
        })
        .catch((error) => {
          console.error('Ошибка регистрации Firebase SW:', error);
          isFirebaseSWRegistering = false;
        });
    }
  }).catch((error) => {
    console.error('Ошибка получения регистраций Service Worker:', error);
  });
}
